import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from 'src/app/shared/service/session.service';
import { Browser } from 'src/app/shared/model/browser.model';
import { LoginForm } from 'src/app/shared/model/loginForm.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-session-browser',
  templateUrl: './browser.component.html',
  styleUrls: ['./browser.component.scss']
})
export class SessionBrowserComponent implements OnInit, OnDestroy {
  @Input() loginForm: LoginForm;
  @Input() browsers: Browser[];
  @Output() afterBrowserRegister = new EventEmitter<{
    loginForm: LoginForm;
    response: Object;
  }>();
  @Output() cancelBrowserRegister = new EventEmitter<any>();

  newBrowserName: string;
  selectedBrowser: Browser;
  private subscriptions: Subscription[] = [];

  constructor(
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerBrowser() {
    const param = {
      ...this.loginForm,
      browser: { name: this.newBrowserName }
    };
    this.newBrowserName = null;

    const sub = this.sessionService.registerBrowser(param).subscribe(
      res => {
        this.afterBrowserRegister.emit({
          loginForm: this.loginForm,
          response: res
        });
      },
      error => {
        let message =
          error.error.errors[0] ||
          'ブラウザ登録に失敗しました. 再度お試しください';
        this.toastrService.error(message);
      }
    );
    this.subscriptions.push(sub);
  }

  openModal(event, browser: Browser, content: TemplateRef<any>) {
    event.target.blur();
    this.selectedBrowser = null;

    // PointerEvent || MouseEvent (eventで取得できるものが違うため)
    if (event.pointerType == 'mouse' || event.detail == 1) {
      this.selectedBrowser = browser;
      this.modalService.open(content, { centered: true });
    }
  }

  deleteBrowser() {
    const sub = this.sessionService
      .deleteBrowser(this.selectedBrowser.id, this.loginForm)
      .subscribe(
        res => {
          this.browsers = this.browsers.filter(
            b => b.id !== this.selectedBrowser.id
          );
          this.modalService.dismissAll();
          this.toastrService.success(
            `${this.selectedBrowser.name}の情報を削除しました`
          );
        },
        error => {
          let message =
            error.error.errors[0] ||
            'ブラウザ情報の削除に失敗しました. 再度お試しください';
          this.toastrService.error(message);
        }
      );
    this.subscriptions.push(sub);
  }

  cancel(event) {
    this.cancelBrowserRegister.emit(event);
  }
}
